import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { AccordionGroup, AccordionContent } from 'core/controls';
import { Translate, TranslateContext } from 'core/translate';
import { SvgIcon } from 'core/icons';
import { combineClassNames, Themed } from 'core/css';
import OptionsAccordionHeader from './OptionsAccordionHeader';
import TrimOption from './TrimOption';

const CompareLink = ({ disabled, styleId, top }) => {
  if (disabled) {
    return null;
  }

  return (
    <TranslateContext.Consumer>
      {translate => (
        <Themed cadillac="button button--link">
          {theme => (
            <div
              className={`trim__compare-link-container ${
                top ? 'trim__compare-link-container--border-bottom' : ''
              }`}>
              <Link
                to={`/trim/compare?styleOne=${styleId}`}
                className={combineClassNames(
                  'trim__compare-link',
                  'stat-text-link',
                  theme
                )}
                data-dtm={translate('component.common.select.trim')}
                id={top ? 'trim-compare' : ''}>
                <Translate value="component.trim.compare.trims" />
                <SvgIcon
                  value="chevron-right"
                  className="svg-icon--small trim__chevron-icon--hide"
                />
              </Link>
            </div>
          )}
        </Themed>
      )}
    </TranslateContext.Consumer>
  );
};

const TrimOptionGroup = ({
  options,
  styleId,
  disclaimer,
  disableCompare,
  onChange
}) => {
  if (options.length === 0) {
    return null;
  }

  return (
    <TranslateContext.Consumer>
      {translate => {
        const header = translate(
          options.length === 1
            ? 'component.common.select.single.trim'
            : 'component.common.select.trim'
        );

        const optionList = _.sortBy(options, [
          'totalMSRPValue',
          'trimName'
        ]).map(option => (
          <TrimOption
            key={option.id}
            option={option}
            disabled={option.selected && options.length === 1}
            disclaimer={disclaimer}
            analyticsKey={header}
            onChange={onChange}
          />
        ));

        return (
          <AccordionGroup id="configuration-trims">
            <OptionsAccordionHeader
              header={header}
              count={options.length}
              hideSingleCount={true}
            />
            <AccordionContent>
              <CompareLink
                styleId={styleId}
                disabled={options.length < 2 || disableCompare}
                top
              />
              {optionList}
              <CompareLink
                styleId={styleId}
                disabled={options.length < 2 || disableCompare}
              />
            </AccordionContent>
          </AccordionGroup>
        );
      }}
    </TranslateContext.Consumer>
  );
};

export default TrimOptionGroup;
